import React from "react";
import TermsAndConditions from "./TermsAndConditions";
import "./TestTerms.css";

const TestTerms = () => {
    const handleAccept = () => {
        alert("Terms accepted! Proceeding...");
    };

    return (
        <div className="test-page-terms">
            <h1 className="test-title-terms">Terms & Conditions Agreement</h1>
            <div className="test-container-terms">
                <TermsAndConditions pdfUrl="/PlusLifeTermsofService.pdf" onAccept={handleAccept} />
            </div>
        </div>
    );
};

export default TestTerms;
